export const SD_TRACK_PITCH = .0785;
export const sdTrackDepth = count => .15 + (Number(count) - 2) * SD_TRACK_PITCH;
export const isSDSourceDesign = design => design?.model_id === 'sd-150' && !design.sd_pocket && Number(design.run_a.panels) === 2 && Math.abs(Number(design.run_a.width_in) * .0254 - 2) < .0001 && Math.abs(Number(design.height_in) * .0254 - 2) < .0001;

export function sd150Layout(design) {
  const width = design.run_a.width_in * .0254, count = Number(design.run_a.panels);
  const panelWidth = (width - .1) / count + .018;
  const pocket = design.sd_pocket ? panelWidth + .10 : 0;
  const stackX = pocket ? -width / 2 - .05 - panelWidth / 2 : -width / 2 + .05 + (width - .1) / count / 2;
  const panels = Array.from({ length: count }, (_, i) => ({
    start: -width / 2 + .05 + (width - .1) / count * (i + .5), target: stackX,
    z: (i - (count - 1) / 2) * SD_TRACK_PITCH,
  }));
  return { width, count, panelWidth, pocket, panels, stackX, tracks: count, depth: sdTrackDepth(count) };
}